import { RadioButton, Pane, StatusMessage } from "components/ui"
import { arrayOf, shape, string, func, array, number, bool } from "prop-types"
import QuestionQuestion from "./QuestionQuestion"
import QuestionKind from "./QuestionKind"
import QuestionDropdownOptions from "./QuestionDropdownOptions"
import QuestionDescription from "./QuestionDescription"
import { Button, StackView } from "@planningcenter/tapestry-react"
import AttendeeRestrictionSelector from "components/admin/AttendeeRestrictionSelector"

const Question = ({
  group,
  question,
  attendeeTypes,
  onQuestionChanged,
  onLimitChanged,
  onLimitAttendeeTypeChanged,
  onKindChanged,
  onRestrictionChanged,
  onAddChoice,
  onUpdateChoice,
  onOptionsReorder,
  onDeleteChoice,
  onMultipleSelectChange,
  onDescriptionChanged,
  editing,
  isSimpleEvent,
  saveStatus,
  onCancel,
  handleSave,
  handleDelete
}) => {
  return (
    <div className="d-f@lg">
      <div className="pr-2@lg f-2 mb-4 mb-0@lg">
        <>
          <Pane>
            <Pane.Header>
              <Pane.Title>Question</Pane.Title>
            </Pane.Header>
            <Pane.Body>
              <StackView axis="horizontal" distribution="stretch" spacing={2} width="100%">
                <QuestionKind question={question} onKindChanged={onKindChanged} editing={editing} />
                <QuestionQuestion
                  onQuestionChanged={onQuestionChanged}
                  label={"Question"}
                  question={question}
                />
              </StackView>

              {(question.kind === "dropdownsingle" || question.kind === "dropdownmult") && (
                <QuestionDropdownOptions
                  question={question}
                  onAddChoice={onAddChoice}
                  onUpdateChoice={onUpdateChoice}
                  onMultipleSelectChange={onMultipleSelectChange}
                  onOptionsReorder={onOptionsReorder}
                  onDeleteChoice={onDeleteChoice}
                />
              )}

              <QuestionDescription
                onDescriptionChanged={onDescriptionChanged}
                question={question}
              />
            </Pane.Body>
          </Pane>
        </>
      </div>

      <div className="pl-2@lg f-1">
        <div className="pane mb-3">
          <div className="pane__header">
            <h3 className="pane__title">Options</h3>
          </div>

          <div className="p-2">
            <div className="label">On Church Center:</div>
            <RadioButton
              text="Optional"
              name="required_on_church_center"
              htmlFor="required_on_church_center_optional"
              checked={!question.publiclyRequired && !question.restrictedToAdmin}
              value="optional"
              onSelect={onRestrictionChanged}
            />
            <RadioButton
              text="Required"
              name="required_on_church_center"
              htmlFor="required_on_church_center_required"
              checked={question.publiclyRequired && !question.restrictedToAdmin}
              value="required"
              onSelect={onRestrictionChanged}
            />
            <RadioButton
              text="Hidden"
              name="required_on_church_center"
              htmlFor="required_on_church_center_hidden"
              checked={!question.publiclyRequired && question.restrictedToAdmin}
              value="hidden"
              onSelect={onRestrictionChanged}
            />
          </div>

          {group != "registrant" && !isSimpleEvent && (
            <div className="p-2 line" css={{ wordBreak: "break-word" }}>
              <div className="label">Available to:</div>
              <AttendeeRestrictionSelector
                attendeeTypes={attendeeTypes.map(at => ({
                  ...at,
                  isAvailable: question.visibleToAttendeeTypeIds.includes(at.id)
                }))}
                onCheckboxChange={onLimitAttendeeTypeChanged}
                hasAttendeeRestriction={question.limitQuestions}
                onAttendeeRestrictionChange={onLimitChanged}
              />
            </div>
          )}
        </div>

        <StackView flexDirection="row" justifyContent="flex-end" spacing={1} marginTop={2}>
          {saveStatus && (
            <div className="mr-a">
              <StatusMessage {...saveStatus} />
            </div>
          )}
          {editing && (
            <Button
              disabled={saveStatus ? true : false}
              theme="destroy"
              onClick={handleDelete}
              title="Delete"
              marginRight="auto"
            />
          )}
          <Button
            disabled={saveStatus ? true : false}
            variant="outline"
            onClick={onCancel}
            title="Cancel"
          />
          <Button
            disabled={!question.question.trim() || !!saveStatus}
            theme="create"
            onClick={handleSave}
            title="Save"
          />
        </StackView>
      </div>
    </div>
  )
}

Question.propTypes = {
  group: string.isRequired,
  question: shape({
    id: number,
    visibleToAttendeeTypeIds: array,
    question: string,
    type: string,
    description: string
  }),
  attendeeTypes: arrayOf(
    shape({
      id: number,
      nameWithRestriction: string
    })
  ),
  onQuestionChanged: func,
  onDescriptionChanged: func,
  onLimitChanged: func,
  onLimitAttendeeTypeChanged: func,
  onKindChanged: func,
  onRestrictionChanged: func,
  onAddChoice: func,
  onUpdateChoice: func,
  onOptionsReorder: func,
  onMultipleSelectChange: func,
  editing: bool,
  onDeleteChoice: func,
  isSimpleEvent: bool,
  onCancel: func,
  handleDelete: func,
  handleSave: func,
  saveStatus: shape({
    text: string,
    icon: string
  })
}

export default Question
